import React, { FC } from 'react'
import { SVGProps } from './types'

export const PlusCircle: FC<SVGProps> = ({
  size = 24,
  width,
  height,
  color = 'currentColor',
  onClick,
}) => {
  const resolvedWidth = width ?? size
  const resolvedHeight = height ?? size

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={resolvedWidth}
      height={resolvedHeight}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      onClick={onClick}
    >
      <circle cx={12} cy={12} r={10} />
      <path d="M8 12h8" />
      <path d="M12 8v8" />
    </svg>
  )
}
